import { Component, OnInit } from '@angular/core';
import { Ng1IpInfoService } from '../../shared/ng1/ng1-ip-info.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../../shared/services/account.service';
import { getPricingSelector } from './pricing-numbers.reducer';
import { Store } from '@ngrx/store';
import { IState } from '../../shared/models/state';
import TYPES from './get-number.type';
import { CountryCallingInfo } from '../../contacts/contact-filters/filter-phone-number/CountryCallingInfo';

@Component({
  selector: 'cc-pricing-numbers',
  templateUrl: './pricing-numbers.component.html',
  styleUrls: ['./pricing-numbers.component.scss']
})
export class PricingNumbersComponent implements OnInit {
  public filtersForm: FormGroup;
  public initialNumberCode: string;
  public isFullyConfigured: boolean;
  public regions: string[] = [];

  constructor(
    private ng1IpInfoService: Ng1IpInfoService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private accountService: AccountService,
    private store: Store<IState>,
    private router: Router
  ) {}

  ngOnInit() {
    const code = this.route.snapshot.paramMap.get('code');
    this.setIsFullyConfigured();
    this.setRegions();
    this.initialNumberCode = !!code ? code.toLowerCase() : this.ng1IpInfoService.getCountry().toLowerCase();
    this.filtersForm = this.fb.group({
      search: [''],
      type: [''],
      region: [''],
      countryCode: [code]
    });

    this.filtersForm.valueChanges.subscribe(form => {
      if (form.type === TYPES.FILTER_TYPE.TOLL_FREE && form.region) {
        this.filtersForm.setValue({ ...form, region: '' });
      }
    });
  }

  setIsFullyConfigured() {
    this.accountService.getAccountConfig().subscribe(conf => {
      this.isFullyConfigured = conf.data;
    });
  }

  setRegions() {
    this.store.select(getPricingSelector).subscribe(pricing => {
      const notUniqueRegions = pricing.filter(item => item.region).map(item => item.region);
      this.regions = Array.from(new Set(notUniqueRegions)).sort();
    });
  }

  get isTollFree() {
    return this.filtersForm.get('type').value === TYPES.FILTER_TYPE.TOLL_FREE;
  }

  changeCountry(callingInfo: CountryCallingInfo) {
    const isValidCountryCode = callingInfo && callingInfo.countryCode;
    const commandsToNavigate = isValidCountryCode
      ? [
          this.isFullyConfigured ? 'get-new-number' : 'get-first-new-number',
          'pricing',
          callingInfo.countryCode.toUpperCase()
        ]
      : [];
    this.router.navigate(commandsToNavigate);
    this.filtersForm.reset({
      search: '',
      type: '',
      region: '',
      countryCode: [callingInfo && callingInfo.countryCode.toLowerCase()]
    });
  }
}
